export default {
    /**  事件类型 */
    Generic: '',
    HeartBeat: '#3598dc',
    AlarmRecover: '#CC00FF',
    Level1Alarm: '#F77478',
    Level2Alarm: '#F7784C',
    Level3Alarm: '#FFAB66',
    Level4Alarm: '#FFD200',

    /** 处理状态 */
    UN_HANDLE: '#f77478',
    HANDLE: '#6CCD3C',
    AutoRecover: '',

    /** 操作类型 */
    Normal: '#3598dc',
    Arm: '#32c5d2',
    Disarm: '#ffab66',
    DisAlarm: '#f77478',
    DisRing: '#FFAB66',

    /** 设备布防状态 */
    ARM_STATE_Arm:'#52c41a',
    ARM_STATE_Disarm:'#f5222d',

    /** 控制操作状态 */
    Success: '#52c41a',
    Failed: '#f5222d',
    Discard: '#FFD200',
    Pendding: '#FFD200',
    Wait: '#FFD200',

    /** 操作触发类型 */
    Initiative: 'green',
    Timer: '#f77478',
    Linkage: '#FFD200',


}